export const WS_CONNECT = "WS_CONNECT";
export const WS_CONNECTING = "WS_CONNECTING";
export const WS_CONNECTED = "WS_CONNECTED";
export const WS_CONNECTION_INFO = "WS_CONNECTION_INFO";
export const WS_DISCONNECT = "WS_DISCONNECT";
export const WS_DISCONNECTED = "WS_DISCONNECTED";
export const WS_CONNECT_ERROR = "WS_CONNECT_ERROR";
export const WS_CONNECT_TIMEOUT = "WS_CONNECT_TIMEOUT";
export const WS_MESSAGE = "WS_MESSAGE";
